import { render, staticRenderFns } from "./UserLeaveApprover.vue?vue&type=template&id=7e965565&scoped=true&"
import script from "./UserLeaveApprover.vue?vue&type=script&lang=js&"
export * from "./UserLeaveApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e965565",
  null
  
)

export default component.exports